import React from 'react';
import { ShieldAlert, RefreshCw, AlertOctagon } from 'lucide-react';

interface MiniAppDisabledScreenProps {
  botName?: string;
  onRetry?: () => void;
}

export function MiniAppDisabledScreen({ botName, onRetry }: MiniAppDisabledScreenProps): React.JSX.Element {
  return (
    <div className="min-h-screen w-full bg-tg-theme-bg text-tg-theme-text flex flex-col items-center justify-center p-6 text-center select-none animate-in fade-in duration-300">
      
      {/* Container Card */}
      <div className="max-w-sm w-full bg-tg-theme-secondary-bg border border-red-500/20 rounded-3xl p-7 shadow-2xl flex flex-col items-center gap-5">
        
        {/* Animated Icon Badge */}
        <div className="w-16 h-16 rounded-2xl bg-red-500/10 border border-red-500/30 flex items-center justify-center text-red-500 shadow-inner">
          <AlertOctagon className="w-9 h-9 animate-pulse" />
        </div>

        {/* Text Header */}
        <div className="flex flex-col gap-2">
          <h2 className="text-lg font-black text-tg-theme-text tracking-tight">
            Доступ к приложению приостановлен
          </h2>
          <p className="text-xs text-tg-theme-hint font-medium leading-relaxed">
            Администратор временно ограничил доступ к Mini App {botName ? <span className="font-bold text-tg-theme-text">{botName}</span> : 'этого бота'} для проведения планового технического обслуживания.
          </p>
        </div>

        {/* Warning Notice */}
        <div className="bg-red-500/5 border border-red-500/10 rounded-xl p-3.5 flex items-start gap-3 text-left w-full">
          <ShieldAlert className="w-5 h-5 text-red-400 shrink-0 mt-0.5" />
          <p className="text-[11px] text-tg-theme-hint leading-snug">
            Все данные вашим записям и клиентам сохранены в безопасности. Доступ будет автоматически восстановлен после завершения работ.
          </p>
        </div>

        {/* Retry Action */}
        <button
          onClick={onRetry || (() => window.location.reload())}
          className="w-full py-3.5 px-4 rounded-xl bg-blue-600 hover:bg-blue-500 text-white font-bold text-xs flex items-center justify-center gap-2 transition-all shadow-md active:scale-98"
        >
          <RefreshCw className="w-4 h-4" />
          Проверить статус снова
        </button>
      </div>

      <span className="text-[10px] text-tg-theme-hint mt-6 opacity-60 font-mono">
        AI TG Business Platform • Code: MINI_APP_DISABLED
      </span>
    </div>
  );
}
